import React, { useState, Fragment } from 'react'
import { StaticQuery, graphql, Link } from "gatsby"
import PropTypes from "prop-types";
import { NavDropdown } from "react-bootstrap"
//import { window, document } from "browser-monads"
import Mcontent from './MegamenuContent/MegamenuContent';

function createMenuHierarchy(menuData, menuName) {
  let tree = [],
     mappedArr = {},
     arrElem,
     mappedElem

  // First map the nodes of the array to an object -> create a hash table.
  for (let i = 0, len = menuData.length; i < len; i++) {
    arrElem = menuData[i].node
    if (arrElem.menu_name === menuName && arrElem.enabled === true) {
      mappedArr[arrElem.drupal_id] = arrElem
      if (arrElem.drupal_parent_menu_item != null && arrElem.drupal_parent_menu_item.includes(arrElem.bundle)) {
        let stripped_drupal_id = arrElem.drupal_parent_menu_item.replace(arrElem.bundle + ':', '')
        mappedArr[arrElem.drupal_id].drupal_parent_menu_item = stripped_drupal_id
      }
      mappedArr[arrElem.drupal_id]['children'] = []
    }
  }

  for (let id in mappedArr) {
    if (mappedArr.hasOwnProperty(id)) {
      mappedElem = mappedArr[id]
      // If the element is not at the root level, add it to its parent array of children.
      if (mappedElem.drupal_parent_menu_item) {
        mappedArr[mappedElem.drupal_parent_menu_item]['children'].push(mappedElem)
      }
      // If the element is at the root level, add it to first level elements array.
      else {
        tree.push(mappedElem)
      }
    }
  }
  return tree
}

// links from drupal come littered
// entity: = node/XXX - this cannot be used
// internal: = path alias - this can be used once the internal part is removed
// Args:
// link = the menu item object
function checkDrupalLink(link) {
  let linkTo = link.link.url
  if(linkTo == null) {
    linkTo = link.link.uri_alias
  }
  if(linkTo == null) {
    linkTo = link.link.uri
  }
  if(linkTo.indexOf('entity:') > -1){
    linkTo = linkTo.replace('entity:', '/')
  }
  else if(linkTo.indexOf('internal:') > -1) {
    linkTo = linkTo.replace('internal:', '')
  }
  return(linkTo)
}


function buildLink(link) {
  let linkTo = checkDrupalLink(link)
  let disabled = false
  // if a node link then disable it as it won't work
  if(linkTo.indexOf('/node/') > -1){
    disabled = true
  }

  if(disabled === true) {
    return (
      <div key={link.drupal_id}  className="nav-item disabled"><Link className="nav-link disabled" to={linkTo} disabled={disabled}>{link.title}</Link></div>
    )
  } else if(link.external === true) {
    return (
      <div key={link.drupal_id}  className="nav-item"><Link className="nav-link" to={linkTo}>{link.title}</Link></div>
    )
  } else {
    return (
      <div key={link.drupal_id}  className="nav-item"><Link className="nav-link" to={linkTo}>{link.title}</Link></div>
    )
  }
}

let menuTopTierIds = []
let timeout = ""

function BuildMenu(menuArray, splitCol) {
  // console.log("buildMenu:")
  // console.log(menuArray)
  const [status, setStatus] = useState(menuArray.map(
    x=> true
  ));

  if(!menuArray)  {
    return
  }
  let menu = []
  let index = 0

  const updateStatus = (value, index) => {
      const clone = [...status];
      clone[index] = value;
      setStatus(clone);
  }

  for(let item in menuArray) {
    if(menuArray[item].children.length !== 0 && menuArray[item].expanded === true) {

      index = menuArray[item].drupal_id
      let linkTo = checkDrupalLink(menuArray[item])
      if(linkTo.indexOf('/node/') > -1){
        linkTo = "#"
      }

      // TOP LEVEL MENU
      // Bootstrap defaults to a click style dropdown
      // - convert this to a hover action dropdown when:
      // 1. the mobile menu is not in use
      // 2. the menu item is a top level tier item, futher tiers remain on click
      if(menuArray[item].drupal_parent_menu_item === null) {
        menuTopTierIds.push(menuArray[item].drupal_id)
        menu.push(
          <Fragment key={"key-"+index}>
            <NavDropdown
              title={menuArray[item].title}
              to={linkTo}
              key={menuArray[item].drupal_id}
              id={menuArray[item].drupal_id}
              onMouseEnter={e => {if(document.getElementsByClassName("navbar-toggler")[0].offsetParent === null) {
                timeout = setTimeout(function(){
                  updateStatus(true, menuArray[item].drupal_id)
                  setTimeout(function(){
                    const hoveredItem = document.querySelector("#site-navbar .show.dropdown.nav-item a.dropdown-toggle")
                    const hoveredMenu = document.querySelector("#site-navbar .show.dropdown-menu")
                    if(hoveredItem) {
                      hoveredItem.href = linkTo
                      hoveredItem.onclick = function(e) {
                        window.scrollTo(0,0)
                        window.location.href = linkTo
                        return true
                      }
                    }
                    if(hoveredMenu) {
                      hoveredMenu.classList.add("active");
                    }
                  }, 100)
                }, 200)

              }}}
              //onMouseEnter={e => {if(document.getElementsByClassName("navbar-toggler")[0].offsetParent === null) updateStatus(true, menuArray[item].drupal_id)}}
              onMouseLeave={e => {
                clearTimeout(timeout)
                if(document.getElementsByClassName("navbar-toggler")[0].offsetParent === null) updateStatus(false, menuArray[item].drupal_id)
              }}
              show={status[index]}
              renderMenuOnMount
            >
              <Mcontent mapTo={menuArray[item].title} />
              {BuildMenu(menuArray[item].children, true)}
            </NavDropdown>
          </Fragment>
        )
      }
      else {
        menu.push(
          <Fragment key={"key-"+index}>
            <div className="nav-item nav-section-header"><Link key={menuArray[item].drupal_id} className="nav-link" to={linkTo}>{menuArray[item].title}</Link></div>
            {BuildMenu(menuArray[item].children, false)}
          </Fragment>
        )
      }

    } else {
      menu.push(buildLink(menuArray[item]))
    }
  }

  // Render items in columns.
  // This is site specific formatting
  let totCols, splitAt = ""
  let totExpanded = 0
  let lastExpandedIndex

  if(splitCol === true) {
    totCols = 2
    // Consider the children of the menu items in this 50 / 50 split
    // First couunt all the links
    let fullCount = 0
    for (let i = 0, len = menuArray.length; i < len; i++) {
      fullCount++
      if(menuArray[i]) {
        if(menuArray[i].children.length) fullCount = fullCount + menuArray[i].children.length

        if(menuArray[i].expanded) {
          totExpanded++
          lastExpandedIndex = i
        }
      }
    }

    let halfCount = Math.ceil(fullCount/totCols)

    // Now find the place to split on
    let splitCount = 0
    for (let i = 0, len = menuArray.length; i < len; i++) {
      splitCount++
      if(menuArray[i]) {
        if(menuArray[i].children.length > 0) splitCount = splitCount + menuArray[i].children.length
      }
      if(splitCount > halfCount) {
        // i is now the half way point considering the children
        splitAt = i
        break
      }
    }

    // As columns are dividing based on half count,
    // if anything found expanded menu then that should fit into other column.
    // So altering splitAt based on last found expandedIndex.
    if(totExpanded > 0 && lastExpandedIndex !== undefined) {
      splitAt = lastExpandedIndex
    }

    // if there are less than 6 items simply add them to the first column
    if(fullCount < 6) splitAt = menu.length

    let menu1 = menu.slice(0, splitAt)
    let menu2 = menu.slice(splitAt, menu.length)
    menu = []
    menu.push(
      <div className="menu-column" key={"key-col1-"+index}>
        {menu1}
      </div>
    )
    menu.push(
      <div className="menu-column" key={"key-col2-"+index}>
        {menu2}
      </div>
    )
  }

  return menu

};

function generateMenu(menuLinks, menuName) {
  //console.log("generateMenu: "+ menuName)
  let menu
  menu = createMenuHierarchy(menuLinks.allMenuLinkContentMenuLinkContent.edges, menuName)
  menu = BuildMenu(menu, false)
  return menu
}

const Menu = ({menuName}) => (

   <StaticQuery
      query={
        graphql`
        query MenuQueryManual {
          allMenuLinkContentMenuLinkContent(sort: {weight: ASC}) {
            edges {
              node {
                enabled
                title
                expanded
                external
                langcode
                weight
                link {
                  uri
                  uri_alias
                }
                drupal_parent_menu_item
                bundle
                drupal_id
                menu_name
              }
            }
          }
        }
      `
      }
      render={data => (
        <Fragment>
          {generateMenu(data, menuName)}
        </Fragment>
      )}
   />
)

Menu.propTypes = {
  menuName: PropTypes.string,
}

Menu.defaultProps = {
  menuName: `main`
}

export default Menu
